<template>
  <div class="modal">
    <b-modal
      id="show-modal-company"
      ref="showModalCompany"
      size="md"
      class="mt-4"
      body-class="p-3 px-lg-5 pt-lg-5"
      @hidden="modalCompanyHide"
      hide-footer
    >
      <template #modal-title>
        Adicionar empresa
        <p class="text-muted mb-0">
          Adicione uma nova empresa ao grupo econômico
        </p>
      </template>
      <div
        v-if="loading"
        class="overlay-modal d-flex align-items-center justify-content-center"
      >
        <div class="d-flex justify-content-center mb-2">
          <b-spinner label="Loading..."></b-spinner>
        </div>
      </div>

      
        <div id="form-cadastrar" class="form">

            <validation-observer ref="observer" v-slot="{ handleSubmit, invalid }">
              <b-form
                @submit.stop.prevent="handleSubmit()"
                class="form"
                autocomplete="off"
              >
               
                <div class="row">
                    <div class="col-md-12 mb-3">
                        <validation-provider
                          name="cnpj do cliente"
                          rules="required|cnpj"
                          v-slot="validationContext"
                          vid="cnpj"
                        >
                          <label class="dbo-ui">CNPJ</label>
                          <b-form-input
                            @blur="onChangeCompanyGroupCnpj"
                            v-model="dataFormEconomicGroupCompany.cnpj"
                            v-mask="'XX.XXX.XXX/XXXX-##'"
                            :state="getValidationState(validationContext)"
                            placeholder="Digite o CNPJ da empresa"
                          ></b-form-input>
                          <b-form-invalid-feedback>{{
                            validationContext.errors[0]
                          }}</b-form-invalid-feedback>
                        </validation-provider>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12 mb-3">
                      <validation-provider
                        name="Nome fantasia do cliente"
                        rules="required"
                        v-slot="validationContext"
                        vid="nome"
                      >
                        <label class="dbo-ui">nome</label>
                        <b-form-input
                          v-model="dataFormEconomicGroupCompany.company_name"
                          :key="dataFormEconomicGroupCompany.company_name"
                          :state="getValidationState(validationContext)"
                          placeholder="Digite o nome da empresa"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback>{{
                          validationContext.errors[0]
                        }}</b-form-invalid-feedback>
                      </validation-provider>
                    </div>
                </div>

                <div class="row mb-5">
                    <div class="col-12 col-lg-12">
                        <label class="dbo-ui" for="new_company_name">Tipo de empresa</label>
                        <div>
                            <b-form-radio
                                v-for="type in economicGroupTypes()"
                                :key="type.id"
                                :value="type.id"
                                v-model="dataFormEconomicGroupCompany.type"
                                class="d-inline-block mr-4 mb-3"
                            >
                              {{ type.label }}
                            </b-form-radio>
                        </div>
                    </div>
                </div>
                
                <div class="row border-top">
                    <div class="col-md-12 mb-3">
                      <div class="modal-footer-buttons">
                        <button
                          class="btn btn-primary"
                          :disabled="invalid"
                          @click="returnEconomicGroup"
                        >
                          Salvar
                        </button>
                      </div>
                    </div>
                </div>

              </b-form>
            </validation-observer>

        </div>

    </b-modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import commonsService from "@/services/commons";
import { mask } from "vue-the-mask";
import commomsHelperMixin from "@/mixins/commomsHelper";

export default {
  name: "EconomicGroup",
  emits: ["returnEconomicGroup"],
  data: () => ({
    loading: false,
    dataFormEconomicGroupCompany: {
      id: '',
      cnpj: '',
      company_name: '',
      address: '',
      type: '',
    }
  }),
  props: {
    economicGroup: {
      type: Object,
    },
  },
  mixins: [commomsHelperMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    mask,
  },
  methods: {
    returnEconomicGroup() {
      this.$emit("setEconomicGroup", this.dataFormEconomicGroupCompany);
    },
    closeModal() {
      if (this.$refs.showModalCompany) {
        this.$refs.showModalCompany.hide();
      }
    },
    modalCompanyHide() {
      this.resetModal();
    },
    onChangeCompanyGroupCnpj: function () {
      const cnpj = this.traitCnpj(this.dataFormEconomicGroupCompany.cnpj);
      if (cnpj) {
        this.loading = true;
        commonsService
          .findCnpj(cnpj)
          .then((response) => {
            if (response.data.error) {
              return;
            }
  
            this.dataFormEconomicGroupCompany.company_name = response.data.name;
            this.dataFormEconomicGroupCompany.address = response.data.address;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    resetModal() {
      this.dataFormEconomicGroupCompany.type = 1;
      this.dataFormEconomicGroupCompany.id = null;
      this.dataFormEconomicGroupCompany.cnpj = null;
      this.dataFormEconomicGroupCompany.company_name = null;
      this.dataFormEconomicGroupCompany.address = null;
      this.dataFormEconomicGroupCompany.index = null;
      this.$refs.showModalCompany.hide();
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  watch: {
      economicGroup: {
        handler(newVal) {
          this.dataFormEconomicGroupCompany = newVal;
        },
        deep: true,
        immediate: true
      }
  }
};
</script>

<style scoped>
.modal-dialog .modal-header h5 p { font-size: 1rem; font-weight: 400; }
.modal-dialog .modal-body { padding-bottom: 0px !important; }
.modal-dialog .modal-footer-buttons { padding: 1rem; text-align: right; padding-top: 1.5rem; padding-bottom: 0px; }
</style>
